import { useQuery } from "@tanstack/react-query";
import { getPaymentAccount } from "../api/payments";

export function usePaymentAccount() {
  return useQuery({
    queryKey: ["paymentAccount"],
    queryFn: getPaymentAccount,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
